export const IPL_TEAMS = {
  CSK:  { name: 'Chennai Super Kings', shortName: 'CSK', color: '#F5A800' },
  MI:   { name: 'Mumbai Indians', shortName: 'MI', color: '#004BA0' },
  RCB:  { name: 'Royal Challengers Bengaluru', shortName: 'RCB', color: '#EC1C24' },
  KKR:  { name: 'Kolkata Knight Riders', shortName: 'KKR', color: '#3A225D' },
  DC:   { name: 'Delhi Capitals', shortName: 'DC', color: '#0078BC' },
  PBKS: { name: 'Punjab Kings', shortName: 'PBKS', color: '#ED1B24' },
  RR:   { name: 'Rajasthan Royals', shortName: 'RR', color: '#EA1A85' },
  SRH:  { name: 'Sunrisers Hyderabad', shortName: 'SRH', color: '#FF6200' },
  GT:   { name: 'Gujarat Titans', shortName: 'GT', color: '#1C1C5E' },
  LSG:  { name: 'Lucknow Super Giants', shortName: 'LSG', color: '#A72B2A' }
};